<!-- Requirement: Bare p-breadcrumb matching the preview-dynamic-report page style.
     No card wrapper — the breadcrumb floats above the main card just like it does on
     the individual report view. Rebuilt by onPathChanged() on every folder navigation. -->
<p-breadcrumb [home]="home" [model]="breadcrumb" styleClass="p-mb-3"></p-breadcrumb>

<!-- Dashboards card — shown only at the reports root, above the search bar -->
<div class="p-card dashboards-card p-mb-3" *ngIf="isRootPath && visibleDashboards.length">
  <div class="p-px-3 p-pt-3 p-pb-1">
    <h3 class="p-mt-0 p-mb-2"><a routerLink="/reports/dashboards" class="dashboards-header-link">Dashboards</a></h3>
  </div>
  <div class="p-px-4 p-pb-3 dashboards-grid">
    <a
      *ngFor="let dashboard of visibleDashboards"
      class="dashboard-tile"
      [routerLink]="['/reports', 'dashboards', dashboard.slug]"
    >
      <i class="pi {{ dashboard.icon }}" style="font-size: 1.5rem" aria-hidden="true"></i>
      <span class="dashboard-tile-name">{{ dashboard.name }}</span>
    </a>
  </div>
</div>

<!-- Requirement: Card 2 — search box (shared), folder directory, and results table.
     DynamicReportsComponent owns the search input so it can scope queries to the
     current folder. When the user is in /Static it emits searchChanged so we can
     proxy the search term to the static reports query. -->
<div class="p-card">
  <app-dynamic-reports
    (pathChanged)="onPathChanged($event)"
    (searchChanged)="onSearchChanged($event)"
  ></app-dynamic-reports>

  <!-- Legacy static reports table — shown only when the user browses the /Static folder.
       The search input has been removed; the shared search bar in app-dynamic-reports
       above drives the reportTypesQH.search via onSearchChanged(). -->
  <ng-container *ngIf="isStaticPath">
    <div class="p-px-3 p-pb-2 p-pt-2">
      <h4 class="p-mt-0 p-mb-2">Static Reports</h4>
    </div>
    <p-table
      #table
      [value]="reportTypes"
      [paginator]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [lazyLoadOnInit]="true"
      [lazy]="true"
      [totalRecords]="reportTypesQH.total"
      [(rows)]="reportTypesQH.limit"
      [rowsPerPageOptions]="pagination.rowPerPageOptions"
      [loading]="reportTypesQH.loading"
      [showCurrentPageReport]="!reportTypesQH.loading"
      breakpoint="620px"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Zone</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rt>
        <tr class="selectable-row" (click)="select(rt)">
          <td>
            <span class="p-column-title">Name:</span>
            {{ rt.name }}
          </td>
          <td>
            <span class="p-column-title">Zone</span>
            <app-zone-chip *ngFor="let zone of rt.zones?.nodes" [zone]="zone">
            </app-zone-chip>
          </td>
          <td class="open-external">
            <span></span>
            <span>
              <a
                *hasPermission="['reports.create']"
                pButton
                type="button"
                routerLink="/reports/type/{{ rt.id }}"
                [queryParams]="{ run: true }"
                icon="pi pi-directions"
                pTooltip="Run {{ rt.name }}"
                data-cy="run-report-type-button"
              ></a>
              <a
                pButton
                type="button"
                routerLink="/reports/type/{{ rt.id }}"
                icon="pi pi-external-link"
                pTooltip="View {{ rt.name }}"
                data-cy="view-report-type-button"
              ></a>
            </span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-car let-columns="columns">
        <tr>
          <td [attr.colspan]="'6'">
            {{ pagination.emptyMessage }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr></tr>
      </ng-template>
    </p-table>
  </ng-container>
</div>

<p-dialog
  #createReportTypeDialog
  header="Report Type Creation Coming Soon"
  [(visible)]="showCreateReportTypeDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
>
  <p>
    Report type creation is coming soon. To request a new report please
    <a href="mailto:support@karveit.ca">email Karve IT</a>
    or
    <a class="clickable" (click)="openFeedback()">submit a request</a>
  </p>

  <p>
    To run an existing report, open that report type then click "Run Report" in
    the top right.
  </p>
</p-dialog>
